(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alyva-stars"] && !Shopify.designMode) return;
  try {
    // Glide to the reviews section instead of jumping, leaving room for the sticky header
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a.alyva-stars');
    if (!link || link.pathname !== window.location.pathname) return;
    var target = document.getElementById('Reviews');
    if (!target) return;
    event.preventDefault();

    var header = document.querySelector('sticky-header, .section-header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    var start = window.scrollY;
    var distance = target.getBoundingClientRect().top - offset;

    // reduced-motion visitors get a short, gentle glide rather than the full one
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = reduced ? 800 : Math.min(1600, Math.max(1000, Math.abs(distance) * 0.7));
    var startTime = null;
    function ease(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    function step(now) {
      if (startTime === null) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      window.scrollTo(0, start + distance * ease(progress));
      if (progress < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
    history.replaceState(null, '', '#Reviews');
  });
  } catch(e) { console.error(e); }
})();

})();
